import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, TermSheetRevision } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useGetTermSheetRevisionQuery(
	dealGuid?: Guid | undefined,
	termSheetGuid?: Guid | null | undefined,
	revisionGuid?: Guid | null | undefined,
	options?:
		| Omit<UseQueryOptions<TermSheetRevision, unknown, TermSheetRevision, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.TermSheets.Revision(dealGuid, termSheetGuid, revisionGuid),
		() =>
			AxiosUtils.getResponseData<TermSheetRevision>(
				api.get(CerebroApiEndpoints.TermSheets.Revision(dealGuid, termSheetGuid, revisionGuid))
			),
		options
	);
}
